import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";

const CNthongtinthue = React.memo(function CNthongtinthue(props) {
  const { baocao_id } = props;
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [masothue, setMasothue] = React.useState("");
  const [tendoanhnghiep, setTendoanhnghiep] = React.useState("");
  const [nothue, setNothue] = React.useState(0);
  const [thoigian_tamngung, setThoigian_tamngung] = React.useState(null);
  const [thoigian_chamdut, setThoigian_chamdut] = React.useState(null);
  const [ghichu, setGhichu] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getthongtin = () => {
    var url =
      Config.backend +
      "/api/BaoCao/getslpl07theoid?id=" +
      baocao_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data[0]) {
          if (data[0].masothue) setMasothue(data[0].masothue);
          if (data[0].tendoanhnghiep) setTendoanhnghiep(data[0].tendoanhnghiep);
          if (data[0].nothue) setNothue(data[0].nothue);
          if (data[0].ghichu) setGhichu(data[0].ghichu);
          let [month, year] = data[0].thang.split("/");
          setThangnam(dayjs(year + "-" + month));
          if (data[0].thoigian_tamngung !== "N/A") {
            let [year, month, day] = data[0].thoigian_tamngung.split("-");
            setThoigian_tamngung(dayjs(year + "/" + month + "/" + day));
          }
          if (data[0].thoigian_chamdut !== "N/A") {
            let [year1, month1, day1] = data[0].thoigian_chamdut.split("-");
            setThoigian_chamdut(dayjs(year1 + "/" + month1 + "/" + day1));
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhat = () => {
    var thangbc = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var ngaytn = null;
    if (thoigian_tamngung) {
      ngaytn =
        thoigian_tamngung.$y +
        "-" +
        String(thoigian_tamngung.$M + 1).padStart(2, "0") +
        "-" +
        thoigian_tamngung.$D;
    }
    var ngaycd = null;
    if (thoigian_chamdut) {
      ngaycd =
        thoigian_chamdut.$y +
        "-" +
        String(thoigian_chamdut.$M + 1).padStart(2, "0") +
        "-" +
        thoigian_chamdut.$D;
    }
    var url = Config.backend + "/api/BaoCao/capnhatslpl07";
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: baocao_id,
        thang: thangbc,
        masothue: masothue,
        tendoanhnghiep: tendoanhnghiep,
        nothue: nothue,
        thoigian_tamngung: ngaytn,
        thoigian_chamdut: ngaycd,
        ghichu: ghichu,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === "1") {
          showNotification();
        } else showNotification1();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  React.useEffect(() => {
    getthongtin();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Tháng báo cáo"
                  value={thangnam}
                  format="MM/YYYY"
                  onChange={(newValue) => {
                    setDisableBT(false);
                    setThangnam(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Mã số thuế"
                variant="outlined"
                size="small"
                value={masothue}
                onChange={(event) => {
                  setMasothue(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Tên doanh nghiệp"
                variant="outlined"
                size="small"
                value={tendoanhnghiep}
                onChange={(event) => {
                  setTendoanhnghiep(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Số thuế còn nợ"
                variant="outlined"
                size="small"
                value={nothue}
                onChange={(event) => {
                  setNothue(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Thời gian tạm ngưng"
                  value={thoigian_tamngung}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setThoigian_tamngung(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Thời gian chấm dứt"
                  value={thoigian_chamdut}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setThoigian_chamdut(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Ghi chú báo cáo"
                variant="outlined"
                size="small"
                value={ghichu}
                onChange={(event) => {
                  setGhichu(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "30px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          disabled={disableBT}
          onClick={capnhat}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

CNthongtinthue.propTypes = {
  baocao_id: PropTypes.number,
};
export default CNthongtinthue;
